import React from "react";

const ModalContainer = ({
  modal_id,
  modal_width,
  bradius,
  max_width,
  showCancelBtn,
  children,
}) => {
  // modal-full-width modal-dialog-centred
  return (
    <div
      className='modal fade'
      id={modal_id}
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='staticBackdropLabel'
      aria-hidden='true'
    >
      <div
        className={`modal-dialog ${modal_width} modal-dialog-centred`}
        style={{ maxWidth: max_width }}
      >
        <div className={`modal-content ${bradius}`}>
          {showCancelBtn && (
            <div className='modal-header border-0 pb-0'>
              <button
                type='button'
                className='btn-close position-absolute'
                data-bs-dismiss='modal'
                aria-hidden='true'
                style={{ top: "-12px", right: "-15px" }}
              ></button>
            </div>
          )}
          <div className='modal-body'>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ModalContainer;
